import AddVehicles from "components/Vehicles/AddVehicles/AddVehicles";
import DialogVhiecles from "components/Vehicles/AddVehicles/DialogVehicles";
import VehicleExcelUpload from "components/Vehicles/VehicleExcelUpload";
import Vehicles from "components/Vehicles/Vehicles";
import React, { Component } from "react";
import { VehicleApiData } from "stores/vehicles/VehicleApi";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import ConfirmDeleteVehicleModel from "components/Vehicles/ConfirmDeleteVehicleModel";
import EditVehicles from "components/Vehicles/AddVehicles/EditVehicles";

function debounce(func, delay) {
  let timer;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}
export default class VehiclesContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "1",
      open: false,
      modelopen: false,
      // open: false,
      dailogcvehicles: false,
      drawerOpen: false,
      addvehicle: false,
      addBulk: false,
      
      Vehicles: true,
      renderComponent: "",
      addSuccess: false,
      inputsearch: "",
      vehiclestypeid:'',
      manufacturerid: "",
      varientid:"",
      model_id: "",
      datePickerOpen: false,
      formData: {
        from_date: "",
        to_date: "",
      },
      filterData:{
        manufacturer: [],
        manufacturer_type: [],
        sub_type: [],
        variant_name: [],
        model_name: [],
        ac_names: [],
        dc_names: [],
      },
      page: 0,
    limit: 100,
    searchkeyword:'',
    sorting:'',
    deleteVehicleOpen:false,
    VehicleId:'',
    deletSuccess:false,
    edit:false,
    editData:{
      id:"",
      manufacturerName:'',
      type: '',
      model_name: '',
      variant: '',
      battery_capacity: '',
      ac_names: [],
      dc_names: [],
      variantName:"",
      batteryCapacity:"",
      acName:[],
      dcName:[],
      editVehicleSuccesmessage: false

      

    }
  
    };
    this.debouncedSearch = debounce(this.performSearch.bind(this), 500);
  }

  performSearch(searchQuery) {
    this.setState({searchkeyword:searchQuery})
    if (searchQuery) {
      this.props.getVehicleData({
        search_term: searchQuery,
        limit: this.state.limit,
        filterData:this.state.filterData,
        from_date: this.state.formData.from_date,
        to_date: this.state.formData.to_date,
        sorting:this.state.sorting
      });
      return;
    } else this.props.getVehicleData({ limit: this.state.limit , from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,});
  }
  handleChangeEditVehicleValue = (key, value) => {
    this.setState((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  handleModelClose = () => {
    this.setState({ modelopen: false });
  
  };
  handleModelOpen = () => {
    this.setState({ modelopen: true });
  };
  handleAddVehicle = (addType) => {
  
    
    if (addType === "addvehicle") {
      this.setState({ renderComponent: "addvehicle" });
      this.setState({ Vehicles: false });
    } else if (addType === "addBulk") {
      this.setState({ renderComponent: "addBulk" });
      this.setState({ modelopen: true });
    } else {
      this.setState({ renderComponent: "" });
    this.setState({edit:false})

    }
  };
  handleChangeSorting = async (event) => {
    const value = event.target.value;
    this.setState({ sorting: value });
    if (value == "All") {
      this.props.getVehicleData("");
    } else {
    try {
      await this.props.getVehicleData({
        from_date: this.state.formData.from_date,
        to_date: this.state.formData.to_date,
        limit: this.state.limit,
        page: this.state.page,
        search_term: this.state.searchkeyword,
        filterData: this.state.filterData,
        sort: value
      });
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
    }
  }
  };
  handleEditVehicle=( vehicle,
    )=>{
    this.setState({edit:true})
    this.setState({
    
      editData: {
        id: vehicle?.id,
        name: vehicle?.name,
        type: vehicle?.type,
        model_name: vehicle?.model_name || "N/A",
        variant: vehicle?.variant || "N/A",
        battery_capacity: vehicle?.battery_capacity || "N/A",
        ac_names: vehicle?.ac_names || "N/A",
        dc_names: vehicle?.dc_names || "N/A",
      }
    })
    
  }
  hanldeEditCloseVehicle =()=>{
    this.setState({edit:false})

  }

  handleDeleteConfirmVehiceClick = (id) => { 
    this.setState({
      deleteVehicleOpen: true,
      VehicleId: id,
    });
  };
  handleCloseVehiceClick = () => { 
    this.setState({
      deleteVehicleOpen: false,
      VehicleId: '',
    });
  };

 
  handleDeleteVehicle = async () => {
    try {
      const res = await VehicleApiData.DeleteConnectorApi(this.state.VehicleId);
      if (res && res.status === 1) {
        const { searchkeyword, limit, filterData, formData, sorting } = this.state;
  
        this.props.getVehicleData({
          search_term: searchkeyword,
          limit: limit,
          filterData: filterData,
          from_date: formData.from_date,
          to_date: formData.to_date,
          sorting: sorting,
        });
        this.handleCloseVehiceClick();
        this.setState({deletSuccess:true})
      } else {
        console.warn("Delete operation unsuccessful:", res);
      }
    } catch (error) {
      console.error("Error deleting connector:", error);
    }
  };

  handleClickEditVehicleSubmit = async () => {
    const { variantName, batteryCapacity, acName, dcName, editData } = this.state;
     const acIds = acName?.map(item => item.id);
     const dcIds = dcName?.map(item => item.id);

    
    try {
      // Make the API call using the correct ID
      const res = await VehicleApiData.UpdateVehicle(editData.id, {
        variant_name: variantName,
        ac_id: acIds,
        dc_id: dcIds,
        battery_capacity: batteryCapacity
      });
    
      // Check if the response is successful
      if (res.status === 1) {
        const { searchkeyword, limit, filterData, formData, sorting } = this.state;
  
        this.props.getVehicleData({
          search_term: searchkeyword,
          limit: limit,
          filterData: filterData,
          from_date: formData.from_date,
          to_date: formData.to_date,
          sorting: sorting,
        });
        this.hanldeEditCloseVehicle()
        this.setState({ editVehicleSuccesmessage: true }); 
      } else {
        // Handle failure, show an error message
        console.error("Failed to update vehicle", res);
      }
    
      // Fetch the updated vehicle variants
      await this.props.getVehicleVariantAction();
    
      // Close the form or dialog
      this.setState({ open: false });
    } catch (error) {
      // Handle any errors that occur during the API request
      console.error("Error updating vehicle:", error);
      // Optionally, show an error message to the user
    }
  };
  
  
  
  
  closeVehicleDaillog = () => {
    this.setState({ dailogcvehicles: false });
    this.handleAddVehicle('back')
    this.handleFilterApiData();
  };
  handleDatePickerOpen = () => {
    this.setState({ datePickerOpen: true });
  };

  onDatePickerSub = async () => {
    this.handleFilterApiData();
  };
  handleDatePickerClose = () => {
    this.setState({ datePickerOpen: false });
  };
  handleChange = (name, value) => {
    const { formData } = this.state;
    if (name === "from_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_from"] = this.formatDateMonth(new Date(value));
    } else if (name === "to_date") {
      formData[name] = this.formatDate(new Date(value));
      formData["fromat_date_to"] = this.formatDateMonth(new Date(value));
    } else {
      formData[name] = value;
    }

    // this.handleFilterApiData();
    this.setState({ formData });
  };
  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }
  formatDateMonth(date) {
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();
    if (day.length < 2) day = "0" + day;

    month = month - 1;

    return [day, monthNames[month], year].join(" ");
  }
  handleFilterApiData = async () => {
    await this.props.getVehicleData({
      from_date: this.state.formData.from_date,
      to_date: this.state.formData.to_date,
      limit: this.state.limit,
      page: this.state.page,
      search_term:this.state.searchkeyword,
      filterData:this.state.filterData,
      sorting:this.state.sorting
    });
  };
  handleReset = async () =>{
    await this.props.getVehicleData({
      limit: this.state.limit,
      page: this.state.page,
      search_term:this.state.searchkeyword
    });
    this.setState({ formData: {
      from_date: "",
      to_date: "",
    }})
  }

  componentDidMount() {
    this.props.getVehicleTypeDataAction()
    this.handleFilterApiData();
    this.props.getVehicleDropdownDataAction();
  }
  handleTabChange = (e, newValue) => {
    this.setState({ value: newValue });
  };
  
  toggleDrawer = (open) => {
    this.setState({ drawerOpen: open });
  };
  submitBulkVehicleData = async (files) => {
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        try {
          const res = await VehicleApiData.postVehicleBulkApi({
            file: files[i],
            type: "IMAGE",
            attachment_of: "Vehicles",
          });

          if (res.status === 1) {
            const { formData } = this.state;
            formData.attachment_ids.push(res.result.id);
            this.setState({ formData });
          }
        } catch (e) {
          console.log(e);
        } finally {
        }
      }
    }
  };

  GetmanufacturerbyvehiclesId = (id) => {
    this.setState({ vehiclestypeid: id });

    this.props.getVehicleMenufaturerData(id);
  };
  GetVarianetByID=(id)=>{
    this.setState({varientid:id})
    this.props.getVehicleSubTypeData(id)

  }
  GetmanufacturerId = (id) => {
    this.setState({ manufacturerid: id });

    this.props.getVehicleModelData(id);
  };
  GetModelId = (model_id) => {
    const manufacturer_id = this.state.manufacturerid;
    this.props.getVehicleVariantData(manufacturer_id, model_id);
  };

  submitVehicleData = (data) => {
    
    this.props.postVehicleData(data);
    this.setState({ dailogcvehicles: true });
    this.props.getAddManufacturerAction();
    this.props.getVehicleDropdownDataAction();
  };


  handleFilter = (data) => {
    if (data && data.manufacturer && data.manufacturer_type) {
      const formattedVehicles = {
        manufacturer: data.manufacturer.map((item) => item.name),
        manufacturer_type: data.manufacturer_type.map((item) => item.name),
        sub_type: data.sub_type?.map((item) => item.name) || [],
        variant_name: data.variant_name?.map((item) => item.name) || [],
        model_name: data.model_name?.map((item) => item.name) || [],
        ac_names: data.ac_names?.map((item) => item.name) || [],
        dc_names: data.dc_names?.map((item) => item.name) || [],
        limit: this.state.limit,
        page: this.state.page,
        search_term:this.state.searchkeyword,
        from_date: this.state.formData.from_date,
        to_date: this.state.formData.to_date,
        
      };
  
      this.props.getVehicleData(formattedVehicles);
  
      this.setState({
        filterData: {
          manufacturer: data.manufacturer.map((item) => item.name),
          manufacturer_type: data.manufacturer_type.map((item) => item.name),
          sub_type: data.sub_type?.map((item) => item.name) || [],
          variant_name: data.variant_name?.map((item) => item.name) || [],
          model_name: data.model_name?.map((item) => item.name) || [],
          ac_names: data.ac_names?.map((item) => item.name) || [],
          dc_names: data.dc_names?.map((item) => item.name) || [],
        }
      });
    } else {
      console.error("Invalid data format:", data);
    }
  };
  

  handleExcelSubmit = async (data) => {
    try {
      const res = await VehicleApiData.postVehicleBulkApi(data);

      if (res.status === 1) {
        this.setState({ modelopen: false });

        this.setState({ addSuccess: true });
      }
      this.props.getVehicleData({
        limit: this.state.limit,
        page: this.state.page,
      });
    } catch (e) {
      console.log("e.error", e.error);
    }
  };
  searchhandleChange = (name, value) => {
    const query = value;
    this.setState({inputsearch: query });
    this.debouncedSearch(query);
  };





  onPageChange = (page, rowsPerPage) => {
    this.setState({
      page: page,
      limit: rowsPerPage,
    });

    const payload = {
      limit: rowsPerPage,
      page: page,
      to_date:this.state.formData.to_date,
      from_date:this.state.formData.from_date,
      search_term: this.state.inputsearch,
      manufacturer: this.state.filterData.manufacturer,
      manufacturer_type: this.state.filterData.manufacturer_type,
      sub_type: this.state.filterData.sub_type,
      variant_name:this.state.filterData.variant_name,
      model_name: this.state.filterData.model_name,
      ac_names: this.state.filterData.ac_names,
      dc_names: this.state.filterData.dc_names,
    };
    this.props.getVehicleData(payload);
  };
  
  render() {    
    
    let vehicleData = this.props.vehicleDataList;
    const vehicleDropdown = this.props.VehicleDropdownDataList;
    
    switch (this.state.renderComponent) {
      case "addvehicle":
        return (
          <>
            <AddVehicles
            subTypesData={ this.props.getVehiclesSubTypedata?.subTypes}
            menufaturerDatabyId={this.props.getMenufacturerdropdowndata?.result?.data}
            saveVehicleTypeId={this.GetmanufacturerbyvehiclesId}
            saveVarientTypeId={this.GetVarianetByID}
              GetmanufacturerId={this.GetmanufacturerId}
              vehicleData={vehicleData}
              handleAddVehicle={this.handleAddVehicle}
              vehicleDropdown={vehicleDropdown}
              submitVehicle={(val) => this.submitVehicleData(val)}
              modelDropdowndata={this.props.getModeldropdowndata.result}
              GetModelId={this.GetModelId}
              variantdropdowndata={
                this.props.getVariantdropdowndata?.result?.data
              }
              vehiclesTypeData={this.props.getVehiclesTypedata?.result}
              handleVarientTypeChange={this.handleVarientTypeChange}
              varientidValue={this.state.varientid}
              edit={this.state.edit}
              editData={this.state.editData}
            />
            <DialogVhiecles
              open={this.state.dailogcvehicles}
              closeVehicles={this.closeVehicleDaillog}
            />
          </>
        );

      default:
        return (
          <>
            <Vehicles
              handleOpen={this.handleModelOpen}
              vehicledata={vehicleData}
              onPageChange={this.onPageChange}
              applyFilter={this.handleFilter}
              handleTabChange={this.handleTabChange}
              value={this.state.value}
              handleAddVehicle={this.handleAddVehicle}
              toggleDrawer={this.toggleDrawer}
              page={this.state?.page}
              limit={this.state?.limit}
              drawerOpen={this.state.drawerOpen}
              isloading={this.props.isLoading}
              searchhandleChange={this.searchhandleChange}
              onChange={this.handleChange}
              datePickerOpen={this.state.datePickerOpen}
              handleDatePickerOpen={this.handleDatePickerOpen}
              handleDatePickerClose={this.handleDatePickerClose}
              from_date={this.state.formData.from_date}
              to_date={this.state.formData.to_date}
              onDatePickerSub={this.onDatePickerSub}
              fromat_date_from={this.state.formData.fromat_date_from}
              fromat_date_to={this.state.formData.fromat_date_to}
              handleReset={this.handleReset}
              handleChangeSorting={this.handleChangeSorting}
              sorting={this.state.sorting}
              handleDeleteConfirmVehiceClick={this.handleDeleteConfirmVehiceClick}
              handleEditVehicle={this.handleEditVehicle}
            />
            <VehicleExcelUpload
              open={this.state.modelopen}
              handleExcelSubmit={this.handleExcelSubmit}
              handleClose={this.handleModelClose}
            />
          
           <ConfirmDeleteVehicleModel
           handleDelete={this.handleDeleteVehicle}
           open={this.state.deleteVehicleOpen}
           handleClose={this.handleCloseVehiceClick}
           />
           <EditVehicles
           open={this.state.edit}
           vehicleDropdown={vehicleDropdown}
           closeVehicles={this.hanldeEditCloseVehicle}
           editData={this.state.editData}
           handleChangeEditVehicleValue={this.handleChangeEditVehicleValue}
           handleClickEditVehicleSubmit={this.handleClickEditVehicleSubmit}

           />
            <Snackbar
              open={this.state.deletSuccess}
              autoHideDuration={3000}
              onClose={() => this.setState({ deletSuccess: false })}
              message="Vehicle deleted successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">Vehicle deleted successfully</Alert>
            </Snackbar>
            <Snackbar
              open={this.state.editVehicleSuccesmessage}
              autoHideDuration={3000}
              onClose={() => this.setState({ editVehicleSuccesmessage: false })}
              message="Vehicle Edit successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">Vehicle Edit successfully</Alert>
            </Snackbar>
            <Snackbar
              open={this.state.addSuccess}
              autoHideDuration={3000}
              onClose={() => this.setState({ addSuccess: false })}
              message="bulk add Successfully"
              anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
              <Alert severity="success">bulk added Successfully</Alert>
            </Snackbar>
          </>
        );
    }
  }
}
